import * as Msdyn365 from '@msdyn365-commerce/core';
import { ensureAuthenticated } from '../../utilities/is-authenticated';
import { trackedAction } from '../../utilities/track-execution-time';

/**
 * SaveExcelConfig Input Action
 */
export class SaveExcelConfigInput implements Msdyn365.IActionInput {
    public excelConfigInput: ISaveExcelConfigData;
    constructor(excelConfigInput: ISaveExcelConfigData) {
        this.excelConfigInput = excelConfigInput;
    }

    public getCacheKey = () => `SaveExcelConfig-${JSON.stringify(this.excelConfigInput)}`;
    public getCacheObjectType = () => 'SaveExcelConfig';
    public dataCacheType = (): Msdyn365.CacheType => 'none';
}

export interface ISaveExcelConfigData {
    Settings: string[];
}

export interface ISaveExcelConfigResponseData {
    '@odata.context': string;
    Success: boolean;
    Message: string;
}

const createInput = (_: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    return new SaveExcelConfigInput({} as ISaveExcelConfigData);
};

async function action(input: SaveExcelConfigInput, ctx: Msdyn365.IActionContext): Promise<ISaveExcelConfigResponseData> {
    ensureAuthenticated(ctx);
    let saveExcelConfigData: ISaveExcelConfigResponseData = {} as ISaveExcelConfigResponseData;

    await Msdyn365.sendRequest(
        `${ctx.requestContext.apiSettings.baseUrl}Commerce/SaveExcelConfig`,
        'post',
        {
            excelConfig: input.excelConfigInput
        },
        {
            headers: {
                OUN: ctx.requestContext.apiSettings.oun,
                Authorization: `id_token ${ctx.requestContext.user.token}`
            }
        }
    )
        .then(res => {
            saveExcelConfigData = res.data as ISaveExcelConfigResponseData;
        })
        .catch(error => {
            console.error('Error saving excel config', error);
            throw new Error('Error saving excel config');
        });
    return saveExcelConfigData;
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<ISaveExcelConfigResponseData>>((input, ctx) => trackedAction(action, input, ctx, 'SaveExcelConfig')),
    id: 'SaveExcelConfig',
    input: createInput
});
